// extracted by mini-css-extract-plugin
module.exports = {"job-content-link-list":"job-content-link-list"};